import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faCheckSquare,
  faClock,
  faFileExcel,
  faHandPointer,
} from "@fortawesome/free-regular-svg-icons";

import {
  faBoxes,
  faChartPie,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faDownload,
  faEdit,
  faEnvelope,
  faFilter,
  faIndustry,
  faListAlt,
  faPencilAlt,
  faPhoneAlt,
  faPowerOff,
  faReceipt,
  faSearch,
  faShareAlt,
  faShieldAlt,
  faSpinner,
  faSyncAlt,
  faTools,
  faTrash,
  faUser,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faCheckSquare,
  faClock,
  faFileExcel,
  faHandPointer,

  faBoxes,
  faChartPie,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faDownload,
  faEdit,
  faEnvelope,
  faFilter,
  faIndustry,
  faListAlt,
  faPencilAlt,
  faPhoneAlt,
  faPowerOff,
  faReceipt,
  faSearch,
  faShareAlt,
  faShieldAlt,
  faSpinner,
  faSyncAlt,
  faTools,
  faTrash,
  faUser,
  faVideo
);
